// extracted by mini-css-extract-plugin
export var externalLink = "_da-0";
export var internalLinkLabel = "_da-1";